// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A12U10).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { DataExport } from '../../features/account/DataExport'
import { meQuery } from '../../shared/org/me'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/account/export')({
  staticData: { screenId: 'AccountExportScreen', access: 'signed in, not demo' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: AccountExportScreen,
})

function AccountExportScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid={ids.accountExport.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('account.export.title')}>
        <p className="text-fg-muted">{t('account.export.lede')}</p>
      </PageHeader>
      <Part testId={ids.accountExport.skeleton}>
        <DataExport />
      </Part>
    </main>
  )
}
